export const PlayBigIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7128 9.43108L5.91301 2.09783C5.82205 2.03606 5.71791 2.00233 5.61132 2.00012C5.50473 1.9979 5.39954 2.02727 5.30655 2.08521C5.21357 2.14315 5.13616 2.22757 5.08228 2.32978C5.0284 2.43198 5 2.5483 5 2.66675V17.3333C5 17.4517 5.0284 17.568 5.08228 17.6702C5.13616 17.7724 5.21357 17.8568 5.30655 17.9148C5.39954 17.9727 5.50473 18.0021 5.61132 17.9999C5.71791 17.9977 5.82205 17.9639 5.91301 17.9022L16.7128 10.5689C16.8006 10.5094 16.873 10.4258 16.9233 10.3261C16.9736 10.2265 17 10.1142 17 10C17 9.88578 16.9736 9.77348 16.9233 9.67386C16.873 9.57424 16.8006 9.49064 16.7128 9.43108Z"
      fill="currentColor"
    />
  </svg>
);
